import { clone } from "lodash"
export default {
  data() {
    return {
      colorArr: [
        '#008CD6 ', '#39A6DF', '#8DCCED'
      ]
    }
  },
  methods: {
    processConfig(config) {
      let primaryTemplate = config.map(item => {
        return { title: item.movie_name, value: item.primary }
      }).sort((pre, cur) => {
        return cur.value - pre.value
      })
      let awareTemplate = config.map(item => {
        return { title: item.movie_name, value: item.awareness }
      }).sort((pre, cur) => {
        return cur.value - pre.value
      })
      this.each_config[0] = {
        //首选
        labels: primaryTemplate.map(item => { return item.title }),
        datasets: [{
          backgroundColor: this.colorArr || this.colorArr[3],
          borderColor: 'rgba(0,0,0,0)',
          hoverBackgroundColor: this.colorArr || this.colorArr[3],
          // hoverBorderColor: this.colorArr || this.colorArr[3],
          borderWidth: 1,
          data: primaryTemplate.map(item => {
            return item.value
          })
        }]
      };

      this.each_config[1] = {
        //认知
        labels: awareTemplate.map(item => { return item.title }),
        datasets: [{
          backgroundColor: this.colorArr || this.colorArr[3],
          borderColor: 'rgba(0,0,0,0)',
          hoverBackgroundColor: this.colorArr || this.colorArr[3],
          // hoverBorderColor: this.colorArr || this.colorArr[3],
          borderWidth: 1,
          data: awareTemplate.map(item => {
            return item.value
          })
        }]
      };
      this.each_config = clone(this.each_config)
    }
  },
}